import { AxiomProvider } from '@optiaxiom/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';
import { PrismBridgeProvider } from '@/lib/prism-bridge';
import { AuthRefetchSync } from './AuthRefetchSync';
import { queryClient } from './queryClient';
import { router } from './router';

export function Providers() {
  return (
    <AxiomProvider>
      <ErrorBoundary>
        <PrismBridgeProvider>
          <QueryClientProvider client={queryClient}>
            <AuthRefetchSync />
            <RouterProvider router={router} />
          </QueryClientProvider>
        </PrismBridgeProvider>
      </ErrorBoundary>
    </AxiomProvider>
  );
}
